import { ReactComponent as ViewIcon } from "@/Images/icons/View.svg"
import { moneyFormat } from "@/utils"
import { useCardTransactions } from "@usher/pe-client-front-end-lib"
import clsx from "clsx"
import type { FC } from "react"
import { memo, useMemo } from "react"
import { ExchangeFilter } from "../Exchange/ExchangeFilter"
import { CardTransactionInfo } from "./CardTransactionInfo"
import { ListBase } from "./ListBase"

type Props = {
  pageSize: number
  isOrdersWithPayouts: boolean
}

const CardsListComponent: FC<Props> = ({ pageSize, isOrdersWithPayouts }) => {
  const { data, dataTotal, pageCount, setFilter, setPage, page, fetchStatement } = useCardTransactions({ page_size: pageSize })

  const tableData = useMemo(() => {
    return data.map((row) => {
      const total_fee = Number(row.fee || 0) + Number(row.fee_fx || 0) + Number(row.fee_pay || 0)
      let amount = Number(row.amount || 0)
      if (amount < 0) amount -= total_fee
      if (amount > 0) amount += total_fee
      return {
        id: <div className="text-[#777e8a]">#{row.id}</div>,
        name: (
          <div className="cursor-pointer hover:text-main-main">
            <CardTransactionInfo id={row.id} transaction={row.transaction}>
              {row.transaction}
            </CardTransactionInfo>
          </div>
        ),
        created: <span>{row.date_created}</span>,
        amount: (
          <>
            <span className={clsx((Number(row.amount) ?? 0) < 0 ? "text-red-500" : "text-green-500")}>
              {moneyFormat(amount)} {row?.currency}
            </span>
          </>
        ),
        card_pan: <span>{row.card_pan}</span>,
        status: <span>{row.status}</span>,
        view: (
          <CardTransactionInfo id={row.id} transaction={row.transaction}>
            <ViewIcon className="cursor-pointer" />
          </CardTransactionInfo>
        ),
      }
    })
  }, [data])

  return (
    <ListBase
      pageSize={pageSize}
      data={tableData}
      total={dataTotal}
      page={page}
      pageCount={pageCount}
      titleMessageId={isOrdersWithPayouts ? "wizarbit-cards-transactions" : "type-card"}
      renderFilter={<ExchangeFilter compact type="Card" withoutExchangeTo onFilter={setFilter} />}
      onDownloadClick={fetchStatement}
      onPageChange={setPage}
    />
  )
}

export const CardsList = memo(CardsListComponent)
